import Vue from 'vue';
import {
    MemberAccountResponseModel,
    PostedTransactionResponseModel,
  } from '@/@types/member';
import GenerateXLSService from '@/services/GenerateXLS.service';


interface Data {
    xlsData: any[];
}

const STATUS_POSTED = 'Posted';
const STATUS_NEEDS_RECEIPT = 'Needs Receipt';

export default Vue.extend({
    data(): Data {
        return {
          xlsData: [],
        };
      },
    computed: {
        account(): MemberAccountResponseModel {
          return this.$store.getters.currentAccount(this.$route.params.id);
        },
        accountKey(): string {
          return this.$route.params.id;
        },
        postedTransactions(): PostedTransactionResponseModel[] {
            return this.$store.getters.postedTransactions;
          },
    },
    methods: {
          getPostedTransactionsDataForXls() {
            this.xlsData = this.postedTransactions.filter((transaction) => [STATUS_POSTED, STATUS_NEEDS_RECEIPT].includes(transaction.transactionStatus))
              .map((transaction: PostedTransactionResponseModel) => {
                  return {
                    postedDate: transaction.postedDate ? this.$options.filters!.moment(transaction.postedDate, 'MM-DD-YY') : '',
                    description: transaction.description,
                    transactionType: transaction.transactionType,
                    paymentAmount: this.$options.filters.transactionFormat(this.$options.filters.currency(transaction.paymentAmount)),
                    startDate: transaction.startDate ? this.$options.filters!.moment(transaction.startDate, 'MM-DD-YY') : '',
                    endDate: transaction.endDate ? this.$options.filters!.moment(transaction.endDate, 'MM-DD-YY') : '',
                    actionRequired: transaction.transactionStatus === STATUS_NEEDS_RECEIPT ? 'Yes' : '',
                    hasAttachment: transaction.hasVault ? 'Yes' : '',
                    note: transaction.noteToSelf ? transaction.noteToSelf : '',
                  };
            });
          },
          createXls() {
            this.getPostedTransactionsDataForXls();
            GenerateXLSService.exportXLS(
                this.xlsData,
                `${this.$options.filters.varReplace(this.$options.filters!.t('xls-transactions-sheet-name'), {accountDescription: this.account.description})}`,
                'activity',
                {
                  postedDate: this.$options.filters!.t('xls-transactions-header-posted-date'),
                  transactionType: this.$options.filters!.t('xls-transactions-header-type'),
                  description: this.$options.filters!.t('xls-transactions-header-description'),
                  paymentAmount: this.$options.filters!.t('xls-transactions-header-amount'),
                  startDate: this.$options.filters!.t('xls-transactions-header-service-from'),
                  endDate: this.$options.filters!.t('xls-transactions-header-service-to'),
                  actionRequired: this.$options.filters!.t('xls-transactions-header-action-required'),
                  hasAttachment: this.$options.filters!.t('xls-transactions-header-has-attachment'),
                  note: this.$options.filters!.t('xls-transactions-header-note'),
                },
            );
          },
    },
});

